import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { spacing, breakpoints, radius, colors, fonts, fontSize } = redesignTheme;

export const useHomePageUniversSectionStyles = makeStyles(() => ({
  universGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: spacing.sm,
    [`@media (min-width: ${breakpoints.mobile}px)`]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    },
    [`@media (min-width: ${breakpoints.desktop}px)`]: {
      gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    },
  },
  universCard: {
    position: 'relative',
    aspectRatio: '243 / 321',
    width: '100%',
    containerType: 'inline-size',
    borderRadius: radius.sm,
    overflow: 'hidden',
    cursor: 'pointer',
    border: 'none',
    padding: 0,
    textAlign: 'left',
    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    },
    '&:hover $universImage': {
      transform: 'scale(1.05)',
    },
  },
  universImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.25s ease',
  },
  universWhiteOverlay: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.14)',
    pointerEvents: 'none',
  },
  universOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(180deg, rgba(217, 217, 217, 0) 0%, rgba(0, 0, 0, 0.85) 100%)',
    pointerEvents: 'none',
  },
  universContent: {
    position: 'absolute',
    left: 'min(9.88cqw, 24px)',
    right: 'min(9.88cqw, 24px)',
    bottom: 'min(6.58cqw, 16px)',
    display: 'flex',
    flexDirection: 'column',
    gap: 'min(3.29cqw, 8px)',
    zIndex: 1,
  },
  universIcon: {
    width: 'min(23.05cqw, 56px)',
    height: 'min(23.05cqw, 56px)',
    flexShrink: 0,
    display: 'block',
  },
  universCardTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: 'min(13.17cqw, 32px)',
    color: colors.white,
    lineHeight: 1.2,
  },
  universCardDescription: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: 'min(7.41cqw, 18px)',
    color: colors.white,
    lineHeight: 1.4,
    minHeight: 'min(31.11cqw, 76px)',
  },
}));
